import { Spin, Row, Col } from "antd";
import React, { Component } from "react";
import { ResponsivePie } from "@nivo/pie";
import axios from "axios";
import { connect } from "react-redux";
import { dineroDisabledMask } from "../../../Components/Items";
import { ResponsiveBar } from "@nivo/bar";

const STYLES = `
  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(20px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes pulse-dot {
    0%, 100% { opacity: 0.4; transform: scale(1); }
    50%       { opacity: 1;   transform: scale(1.5); }
  }

  /* ── Contenedor principal ── */
  .dash-root {
    background: #ffffff;
    border-radius: 20px;
    padding: 32px 32px 40px;
    /* sin position:fixed ni backdrop-filter para evitar z-index conflicts */
  }

  /* ── Header ── */
  .dash-header {
    margin-bottom: 32px;
    animation: fadeUp 0.5s cubic-bezier(0.22,1,0.36,1) both;
  }
  .dash-eyebrow {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: #00BFD6;
    margin-bottom: 8px;
  }
  .dash-eyebrow-bar {
    display: inline-block;
    width: 24px; height: 2.5px;
    background: #00BFD6;
    border-radius: 4px;
    flex-shrink: 0;
  }
  .dash-live-dot {
    width: 7px; height: 7px;
    border-radius: 50%;
    background: #00BFD6;
    flex-shrink: 0;
    animation: pulse-dot 2s ease-in-out infinite;
  }
  .dash-title {
    font-size: 26px;
    font-weight: 700;
    color: #0f172a;
    margin: 0 0 4px;
    letter-spacing: -0.02em;
    line-height: 1.2;
  }
  .dash-subtitle {
    font-size: 13px;
    color: #94a3b8;
    font-weight: 500;
    margin: 0;
  }

  /* ── Separador entre header y grids ── */
  .dash-sep {
    height: 1px;
    background: #f1f5f9;
    margin-bottom: 28px;
  }

  /* ── Cards de gráfica ── */
  .dash-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 20px 22px 18px;
    height: 420px;
    /* NO backdrop-filter, NO position:fixed — evita stacking context conflicts */
    box-shadow: 0 1px 4px rgba(0,0,0,0.05), 0 4px 16px rgba(0,0,0,0.04);
    opacity: 0;
    animation: fadeUp 0.55s cubic-bezier(0.22,1,0.36,1) both;
    transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.2s ease;
  }
  .dash-card:hover {
    border-color: rgba(0,191,214,0.35);
    box-shadow: 0 4px 24px rgba(0,191,214,0.1), 0 1px 6px rgba(0,0,0,0.06);
    transform: translateY(-2px);
  }

  /* barra de color en la parte superior de cada card */
  .dash-card-accent {
    height: 3px;
    border-radius: 3px;
    background: linear-gradient(90deg, #00BFD6, #22d3ee);
    margin-bottom: 16px;
    width: 40px;
  }

  .dash-card-label {
    font-size: 9.5px;
    font-weight: 800;
    letter-spacing: 0.13em;
    text-transform: uppercase;
    color: #00BFD6;
    margin-bottom: 2px;
  }
  .dash-card-title {
    font-size: 15px;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
    letter-spacing: -0.01em;
  }
  .card-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 14px;
  }
  .card-divider {
    height: 1px;
    background: #f1f5f9;
    margin-bottom: 14px;
  }
  .chart-wrap {
    height: calc(100% - 90px);
  }

  .dash-period-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: #f0fdff;
    border: 1px solid #a5f3fc;
    color: #0891b2;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.05em;
    padding: 3px 10px;
    border-radius: 20px;
    white-space: nowrap;
    flex-shrink: 0;
  }
  .pill-dot {
    width: 5px; height: 5px;
    border-radius: 50%;
    background: #00BFD6;
    flex-shrink: 0;
  }

  .dash-spin .ant-spin-dot-item { background: #00BFD6 !important; }

  @media (max-width: 767px) {
    .dash-root {
      padding: 20px 14px 28px;
      border-radius: 14px;
    }
    .dash-title { font-size: 20px; }
    .dash-subtitle { font-size: 12px; }
    .dash-card {
      height: 280px;
      padding: 14px 14px 12px;
    }
    .chart-wrap { height: calc(100% - 72px); }
    .dash-card-accent { margin-bottom: 10px; }
    .card-head { margin-bottom: 8px; }
  }
`;

const PIE_COLORS = [
  "#00BFD6","#6366f1","#0ea5e9","#a78bfa",
  "#34d399","#f59e0b","#f97316","#ec4899",
  "#10b981","#8b5cf6",
];
const BAR_CASHFLOW  = ["#f97316","#fb923c","#0891b2","#06b6d4","#eab308"];
const BAR_PRODUCTOS = ["#00BFD6","#f97316","#10b981"];

const NIVO_THEME = {
  background: "transparent",
  text: { fill: "#94a3b8", fontSize: 10.5, fontFamily: "'Plus Jakarta Sans', sans-serif" },
  grid:  { line: { stroke: "#f1f5f9", strokeWidth: 1 } },
  axis:  { ticks: { text: { fill: "#94a3b8", fontSize: 10 } } },
  tooltip: {
    container: {
      background: "#ffffff",
      color: "#1e293b",
      border: "1px solid #e2e8f0",
      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
      borderRadius: 10,
      fontSize: 12,
    },
  },
};

class Inicio extends Component {
  state = {
    loading: false,
    ventasPorFamilia: [],
    comprasPorFamilia: [],
    flujoDeEfectivo: [],
    productosMasVendidos: [],
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.consultarVentasPorFamilia();
    this.consultarFlujoDeEfectivo();
    this.consultarProductosMasVendidos();
    this.consultarComprasPorFamilia();
  }

  async consultarVentasPorFamilia() {
    await axios
      .post("inicio/ventasPorFamilia", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => { if (res.data.status !== 404) this.setState({ ventasPorFamilia: res.data }); });
  }
  async consultarComprasPorFamilia() {
    await axios
      .post("inicio/comprasPorFamilia", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => { if (res.data.status !== 404) this.setState({ comprasPorFamilia: res.data }); });
  }
  async consultarFlujoDeEfectivo() {
    await axios
      .post("inicio/flujoDeEfectivo", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => { if (res.data.status !== 404) this.setState({ flujoDeEfectivo: res.data }); });
  }
  async consultarProductosMasVendidos() {
    await axios
      .post("inicio/productosMasVendidos", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => { if (res.data.status !== 404) this.setState({ productosMasVendidos: res.data }); });
  }

  render() {
    const isMobile = window.innerWidth < 768;

    const tooltip = (color, title, value, label) => (
      <div style={{
        padding: "10px 14px",
        background: "#fff",
        border: "1px solid #e2e8f0",
        borderRadius: 10,
        boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
        fontSize: 12,
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        minWidth: 150,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 5 }}>
          <span style={{ width: 8, height: 8, borderRadius: 999, background: color, flexShrink: 0 }} />
          <span style={{ fontWeight: 700, color: "#1e293b", fontSize: 12 }}>{title}</span>
        </div>
        {label && <div style={{ color: "#94a3b8", marginBottom: 2, fontSize: 11 }}>{label}</div>}
        <div style={{ color: "#00BFD6", fontWeight: 700, fontSize: 14 }}>
          {dineroDisabledMask(Math.abs(value))}
        </div>
      </div>
    );

    const tooltipDetalle = (color, title, rows) => (
      <div style={{
        padding: "10px 14px",
        background: "#fff",
        border: "1px solid #e2e8f0",
        borderRadius: 10,
        boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
        fontSize: 12,
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        minWidth: 170,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 6 }}>
          <span style={{ width: 8, height: 8, borderRadius: 999, background: color, flexShrink: 0 }} />
          <span style={{ fontWeight: 700, color: "#1e293b", fontSize: 12 }}>{title}</span>
        </div>
        {rows.map((row) => (
          <div key={row.label} style={{ display: "flex", justifyContent: "space-between", gap: 14, marginBottom: 2 }}>
            <span style={{ color: "#94a3b8", fontSize: 11 }}>{row.label}</span>
            <span style={{ color: "#00BFD6", fontWeight: 700, fontSize: 12 }}>
              {dineroDisabledMask(Math.abs(row.value))}
            </span>
          </div>
        ))}
      </div>
    );

    // En mobile se ocultan las leyendas y se reducen márgenes para que la gráfica respire
    const pieLegendRight = isMobile ? [] : [
      {
        anchor: "right",
        direction: "column",
        translateX: 145,
        translateY: 0,
        itemsSpacing: 7,
        itemWidth: 145,
        itemHeight: 18,
        itemTextColor: "#64748b",
        symbolSize: 9,
        symbolShape: "circle",
        effects: [{ on: "hover", style: { itemTextColor: "#0f172a" } }],
      },
    ];

    const pieLegendBottom = isMobile ? [] : [
      {
        anchor: "bottom",
        direction: "row",
        translateY: 50,
        itemsSpacing: 12,
        itemWidth: 110,
        itemHeight: 18,
        itemTextColor: "#64748b",
        symbolSize: 9,
        symbolShape: "circle",
        effects: [{ on: "hover", style: { itemTextColor: "#0f172a" } }],
      },
    ];

    const pieMarginRight  = isMobile ? { top: 10, right: 10, bottom: 10, left: 10 } : { top: 8, right: 200, bottom: 16, left: 16 };
    const pieMarginBottom = isMobile ? { top: 10, right: 10, bottom: 10, left: 10 } : { top: 8, right: 16, bottom: 60, left: 16 };
    const barLeftMargin   = isMobile ? 56 : 90;
    const barBottomCashflow  = isMobile ? 68 : 88;
    const barBottomProductos = isMobile ? 92 : 130;
    const cashflowLegendY    = isMobile ? 60 : 80;
    const cashflowItemWidth  = isMobile ? 90 : 116;

    return (
      <>
        <style>{STYLES}</style>
        <div className="dash-root">
          <Spin spinning={this.state.loading} wrapperClassName="dash-spin">

            {/* ── Header ── */}
            <div className="dash-header">
              <div className="dash-eyebrow">
                <span className="dash-eyebrow-bar" />
                Panel de Control
              </div>
              <h1 className="dash-title">Resumen de tu Empresa</h1>
              <p className="dash-subtitle">Métricas basadas en los últimos 7 días</p>
            </div>
            <div className="dash-sep" />

            {/* ── Fila 1 ── */}
            <Row gutter={[20, 20]}>
              <Col xs={24} md={12}>
                <div className="dash-card" style={{ animationDelay: "0.06s" }}>
                  <div className="card-head">
                    <div>
                      <div className="dash-card-label">Ingresos</div>
                      <h2 className="dash-card-title">Ventas por Familia</h2>
                    </div>
                    <span className="dash-period-pill">
                      <span className="pill-dot" />7 días
                    </span>
                  </div>
                  <div className="dash-card-accent" />
                  <div className="chart-wrap">
                    <ResponsivePie
                      data={this.state.ventasPorFamilia}
                      margin={pieMarginRight}
                      colors={PIE_COLORS}
                      sortByValue={true}
                      innerRadius={0.67}
                      padAngle={1.8}
                      cornerRadius={6}
                      id={(e) => e.label}
                      valueFormat={(e) => dineroDisabledMask(Math.abs(e))}
                      activeOuterRadiusOffset={9}
                      borderWidth={0}
                      enableArcLabels={false}
                      arcLinkLabelsSkipAngle={isMobile ? 360 : 14}
                      arcLinkLabelsTextColor="#94a3b8"
                      arcLinkLabelsThickness={1}
                      arcLinkLabelsColor={{ from: "color" }}
                      theme={NIVO_THEME}
                      legends={pieLegendRight}
                      tooltip={({ datum }) => tooltipDetalle(datum.color, datum.label, [
                        { label: "Venta", value: datum.data.value },
                        { label: "Costo", value: datum.data.costo },
                        { label: "Utilidad", value: datum.data.utilidad },
                      ])}
                    />
                  </div>
                </div>
              </Col>

              <Col xs={24} md={12}>
                <div className="dash-card" style={{ animationDelay: "0.12s" }}>
                  <div className="card-head">
                    <div>
                      <div className="dash-card-label">Tesorería</div>
                      <h2 className="dash-card-title">Flujo de Efectivo</h2>
                    </div>
                    <span className="dash-period-pill">
                      <span className="pill-dot" />7 días
                    </span>
                  </div>
                  <div className="dash-card-accent" style={{ background: "linear-gradient(90deg, #f97316, #fb923c)" }} />
                  <div className="chart-wrap">
                    <ResponsiveBar
                      data={this.state.flujoDeEfectivo}
                      keys={["Saldo Inicial","Movimientos del dia","Cuentas por Pagar","Cuentas por Cobrar","Saldo Final"]}
                      indexBy="dia"
                      valueFormat={(e) => dineroDisabledMask(Math.abs(e))}
                      margin={{ top: 8, right: 8, bottom: barBottomCashflow, left: barLeftMargin }}
                      padding={0.25}
                      innerPadding={2}
                      groupMode="grouped"
                      valueScale={{ type: "linear" }}
                      indexScale={{ type: "band", round: true }}
                      colors={BAR_CASHFLOW}
                      colorBy="id"
                      borderRadius={4}
                      borderColor={{ from: "color", modifiers: [["darker", 1.2]] }}
                      axisTop={null}
                      axisRight={null}
                      axisBottom={{
                        tickSize: 0,
                        tickPadding: 10,
                        tickRotation: 45,
                        tickValues: this.state.flujoDeEfectivo?.map(d => d.dia)?.filter((_, i) => i % 2 === 0),
                      }}
                      axisLeft={{
                        tickSize: 0,
                        tickPadding: 10,
                        format: (v) => dineroDisabledMask(Math.abs(v)),
                      }}
                      enableGridX={false}
                      gridYValues={4}
                      enableLabel={false}
                      theme={NIVO_THEME}
                      tooltip={({ id, value, indexValue, color }) => tooltip(color, indexValue, value, id)}
                      legends={isMobile ? [] : [
                        {
                          dataFrom: "keys",
                          anchor: "bottom",
                          direction: "row",
                          translateY: cashflowLegendY,
                          itemWidth: cashflowItemWidth,
                          itemHeight: 16,
                          itemsSpacing: 4,
                          symbolSize: 8,
                          symbolShape: "circle",
                          itemTextColor: "#64748b",
                          effects: [{ on: "hover", style: { itemTextColor: "#1e293b" } }],
                        },
                      ]}
                    />
                  </div>
                </div>
              </Col>
            </Row>

            {/* ── Fila 2 ── */}
            <Row gutter={[20, 20]} style={{ marginTop: 20 }}>
              <Col xs={24} md={12}>
                <div className="dash-card" style={{ animationDelay: "0.18s" }}>
                  <div className="card-head">
                    <div>
                      <div className="dash-card-label">Ranking</div>
                      <h2 className="dash-card-title">Productos más Vendidos</h2>
                    </div>
                    <span className="dash-period-pill">
                      <span className="pill-dot" />7 días
                    </span>
                  </div>
                  <div className="dash-card-accent" style={{ background: "linear-gradient(90deg, #0ea5e9, #38bdf8)" }} />
                  <div className="chart-wrap">
                    <ResponsiveBar
                      data={this.state.productosMasVendidos}
                      keys={["venta", "costo", "utilidad"]}
                      indexBy="label"
                      valueFormat={(e) => dineroDisabledMask(Math.abs(e))}
                      margin={{ bottom: barBottomProductos, left: barLeftMargin, top: 8, right: 8 }}
                      padding={0.3}
                      innerPadding={2}
                      groupMode="grouped"
                      valueScale={{ type: "linear" }}
                      indexScale={{ type: "band", round: true }}
                      borderRadius={6}
                      borderColor={{ from: "color", modifiers: [["darker", 1.4]] }}
                      axisBottom={{
                        tickSize: 0,
                        tickPadding: 10,
                        tickRotation: -35,
                        format: (v) => v && v.length > 16 ? `${v.substring(0, 16)}…` : v,
                      }}
                      axisLeft={{
                        tickSize: 0,
                        tickPadding: 8,
                        format: (e) => dineroDisabledMask(Math.abs(e)),
                      }}
                      axisTop={null}
                      axisRight={null}
                      enableLabel={false}
                      colors={BAR_PRODUCTOS}
                      colorBy="id"
                      theme={NIVO_THEME}
                      tooltip={({ id, value, indexValue, color }) => tooltip(color, indexValue, value, id.charAt(0).toUpperCase() + id.slice(1))}
                      legends={isMobile ? [] : [
                        {
                          dataFrom: "keys",
                          anchor: "bottom",
                          direction: "row",
                          translateY: 92,
                          itemWidth: 90,
                          itemHeight: 16,
                          itemsSpacing: 4,
                          symbolSize: 8,
                          symbolShape: "circle",
                          itemTextColor: "#64748b",
                          effects: [{ on: "hover", style: { itemTextColor: "#1e293b" } }],
                        },
                      ]}
                    />
                  </div>
                </div>
              </Col>

              <Col xs={24} md={12}>
                <div className="dash-card" style={{ animationDelay: "0.24s" }}>
                  <div className="card-head">
                    <div>
                      <div className="dash-card-label">Egresos</div>
                      <h2 className="dash-card-title">Compras por Familia</h2>
                    </div>
                    <span className="dash-period-pill">
                      <span className="pill-dot" />7 días
                    </span>
                  </div>
                  <div className="dash-card-accent" style={{ background: "linear-gradient(90deg, #6366f1, #a78bfa)" }} />
                  <div className="chart-wrap">
                    <ResponsivePie
                      data={this.state.comprasPorFamilia}
                      margin={pieMarginBottom}
                      colors={PIE_COLORS}
                      sortByValue={true}
                      innerRadius={0.67}
                      padAngle={1.8}
                      cornerRadius={6}
                      id={(e) => e.label}
                      valueFormat={(e) => dineroDisabledMask(Math.abs(e))}
                      activeOuterRadiusOffset={9}
                      borderWidth={0}
                      enableArcLabels={false}
                      arcLinkLabelsSkipAngle={isMobile ? 360 : 14}
                      arcLinkLabelsTextColor="#94a3b8"
                      arcLinkLabelsThickness={1}
                      arcLinkLabelsColor={{ from: "color" }}
                      theme={NIVO_THEME}
                      legends={pieLegendBottom}
                      tooltip={({ datum }) => tooltip(datum.color, datum.label, datum.value)}
                    />
                  </div>
                </div>
              </Col>
            </Row>

          </Spin>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(Inicio);
